/** @jsx jsx */
import { Box, jsx } from "theme-ui";
import React, { PropsWithChildren } from "react";
import PageFooter from "../page-footer/page-footer";


type LayoutProps = PropsWithChildren;
export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <main
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
     { /*<Helmet>
        <script type="text/javascript" src="../../../zendesk.js" defer={true} />
    </Helmet>*/}
      {children}
      <PageFooter />
    </main>
  );
};

export default Layout;
